module.exports = __webpack_public_path__ + "img/web-banner.b77eeed9.png";